// extracted by css-extract-rspack-plugin
export default {"root":"ErpText_root__5XtDh"};